const maintenancesTab = {
  button: 'ADICIONAR NOVA MANUTENÇÃO',
  text: 'NENHUMA MANUTENÇÃO CADASTRADA',
  loadMoreButton: 'CARREGAR MAIS',
};

export default maintenancesTab;